import * as amplitude from "@amplitude/analytics-browser";

import type { AmplitudeInitArgs } from "@tvg/amplitude/types";
import { amplitudeInit } from "@tvg/amplitude";
import { isXSell } from "@tvg/sh-utils/mobileUtils";
import { FDR_PAGE_CONFIG } from "./constants";
import useXSellPlugin from "./useXSellPlugin";

export default ({
  getGlobalProperties,
  options = { identityStorage: "localStorage", minIdLength: 1 },
  extra
}: AmplitudeInitArgs) => {
  amplitudeInit({
    getGlobalProperties,
    pagesConfig: FDR_PAGE_CONFIG,
    options,
    extra
  });

  if (isXSell()) amplitude.add(useXSellPlugin());
};
